// dynamicConfig.js
let currentConfig = {};

export const setConfig = (config) => {
  currentConfig = config;
};

export const getConfig = () => currentConfig;
